import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const VerifiedDomains = lazy(() =>
  import("@scenes/VerifiedDomains").then((module) => ({
    default: module.VerifiedDomains,
  }))
);

export const verifiedDomainsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: VerifiedDomains,
  heading: (t: I18nT<"dashboard-navigation">) => t("domains-nro-heading", "Verified Domains"),
  pageNameForTracking: () => "Verified Domains",
  tag: "new",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  defaultRoute: "/company_settings/verified_domains/:appGroupId",
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return (
      hasPermission("company", { permission: "viewDomainSettings" }) ||
      hasPermission("company", { permission: "editDomainSettings" })
    );
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("domains-nro-additional-keyword-delegated-domains", "delegated domains"),
        t("domains-nro-additional-keyword-domain-delegation", "domain delegation"),
        t("domains-nro-additional-keyword-verified-domains", "verified domains"),
        t("domains-nro-additional-keyword-dns-delegation", "DNS delegation"),
        t("domains-nro-additional-keyword-domain-management", "domain management"),
        t("domains-nro-additional-keyword-manage-domains", "manage domains"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
